import React, {PureComponent} from 'react';
import {inject, observer} from 'mobx-react';
import {StripeProvider, Elements} from 'react-stripe-elements';
import {STRIPE_KEY} from 'constants/stripe';
import {TopicItem} from '../components';
import {SUBSCRIPTIONS_PRICES} from '../constants';
import CardForm from '../../profile/components/CardForm';
import HttpClient from 'services/HttpClient';

const TOPICS_REQUEST = '/api/v1/tutorials?';
const SUBSCRIPTIONS = '/api/v1/subscriptions';

@inject('examPrepHeaderStore')
@inject('userStore')
@inject('topicsStore')
@inject('alertStore')
@observer
export default class ExamPrepDashboard extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      payments: [],
      showPaymentModal: false,
      tutorial_id: null,
      buttonText: '€ 595 – Purchase',
      title: 'An',
      stripe: null,
      subscriptionOption: {},
      type: '',
    };
  }

  componentDidMount() {
    const {examPrepHeaderStore: {clear}, topicsStore, userStore} = this.props;
    
    new HttpClient().get(`${TOPICS_REQUEST}tutorial_types[]=1&tutorial_types[]=2`).then(response => {
      topicsStore.setTopics(response.body.data.tutorial);
    });
    new HttpClient().get(SUBSCRIPTIONS).then(data => {
      if(data.body.data.transctions)
        this.setState({payments: data.body.data.transctions, active: data.body.data.active})
    });

    if (window.Stripe) {
      this.setState({stripe: window.Stripe(STRIPE_KEY)});
    } else {
      document.querySelector('#stripe-js').addEventListener('load', () => {
        // Create Stripe instance once Stripe.js loads
        this.setState({stripe: window.Stripe(STRIPE_KEY)});
      });
    }

    clear();
  }

  handleClick = topic => {
    const {examPrepHeaderStore: {setTopic}} = this.props;
    setTopic(topic);
  };

  changeSubscriptionOption = event => {
    const {name, value} = event.target;

    this.setState({
      subscriptionOption: {
        ...this.state.subscriptionOption,
        ...{[name]: value},
      },
    })
  }

  handleExamStripeModal = (tutorial) => {
    const {showPaymentModal} = this.state;

    this.setState({
      showPaymentModal: !showPaymentModal,
      tutorial_id: tutorial.id,
      title: tutorial.title,
      type: tutorial.tutorial_type || '',
    });
  };

  handleStripeModal = () => {
    const {showPaymentModal} = this.state;

    this.setState({showPaymentModal: !showPaymentModal});
  };

  onToken = e => {
    const {tutorial_id, type, subscriptionOption} = this.state;

    return new HttpClient().post(SUBSCRIPTIONS, {
      token: e.id,
      tutorial_id,
      subs_type: subscriptionOption[type] || 0,
    });
  };

  render() {
    const {payments, showPaymentModal, buttonText, title, stripe, subscriptionOption, type} = this.state;
    const {topicsStore, userStore} = this.props;
    const {clearTopics} = topicsStore;
    // const cost = SUBSCRIPTIONS_PRICES[subscriptionOption[type]] || 595;
    const cost = subscriptionOption[type] ? SUBSCRIPTIONS_PRICES[type][subscriptionOption[type]] : (type === 'cct' ? 795 : 595);

    return (
        <section className="section exam-prep-dashboard">
          <div className="container-fluid">
            <div className="list-container">
              <h1>MEDICAL EDUCATION</h1>
              <h2>MADE EASY</h2>
              <div className='list-wrapper'>
                {clearTopics.map(topic => (
                  <TopicItem
                    key={topic.id}
                    topic={topic}
                    payments={payments}
                    handleClick={this.handleClick}
                    handleExamStripeModal={this.handleExamStripeModal}
                    changeSubscriptionOption={this.changeSubscriptionOption}
                    subscriptionOption={subscriptionOption}
                  />
                ))}
              </div>
              <div className="row list-title">
                <p>{'PLUS podcasts and videos on > 50 topics covering conditions seen in everyday practice'}</p>
                <p>Note: Both CKT EXAM PREP and CCT EXAM PREP modules are fully reimbursable under the training support scheme (TSS) and ICGP specialist funding</p>
              </div>
            </div>
          </div>
          <StripeProvider stripe={stripe}>
            <Elements>
              <CardForm
                onToken={this.onToken}
                cost={`€ ${cost} – Purchase`}
                hideStripeModal={this.handleStripeModal}
                showStripeModal={showPaymentModal}
                email={userStore.user.email}
                title={title}
              />
            </Elements>
          </StripeProvider>
        </section>
    );
  }
};



// WEBPACK FOOTER //
// ./src/modules/examPrepDashboard/containers/ExamPrepDashboard.js